import type { ResolveWhitelabelConfigResponse } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

export function useResolveWhitelabelbyRequestId(requestId: number | undefined) {
  return useQuery<ResolveWhitelabelConfigResponse>({
    enabled: !!requestId,
    queryFn: () =>
      apiClient.url(`/whitelabel/resolve/request/${requestId}`).get().json(),
    queryKey: ["whitelabe", "request", requestId],
  });
}
